import {Flex} from "@chakra-ui/react";

const ProductName = () => <Flex direction={"row"} gap={2} justifyContent={"center"} alignItems={"center"}>
    Stake Metrics
</Flex>;

export default ProductName;
